// extracted by mini-css-extract-plugin
export default {"container":"becomeAPartner_container__t4e2v"};